/* eslint-disable no-continue */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import moment from "moment"

const MINOR_LABELS = {
  1: "Tarjeta válida",
  2: "Tarjeta inválida",
  3: "Tarjeta caducada",
  4: "Sin autorización de horario",
  5: "Acceso denegado",
  8: "Huella dactilar",
  22: "Contraseña",
  24: "Código QR",
  37: "Contraseña incorrecta",
  38: "Reconocimiento facial — OK",
  39: "Reconocimiento facial — Fallido",
  43: "Tarjeta + Rostro",
  60: "Puerta abierta",
  61: "Puerta cerrada",
  62: "Alarma puerta abierta",
  63: "Apertura normal",
  75: "Reconocimiento facial",
  76: "Reconocimiento facial — Umbral bajo",
}

const getMinorLabel = c => MINOR_LABELS[c] ?? `Sub-evento ${c}`

const HEX_RE = /^[0-9a-f]{40,}$/i
const isHashed = v => typeof v === "string" && HEX_RE.test(v.trim())

function getAccessResult(item) {
  if (item.major !== 5) return "info"
  const OK = [1, 8, 22, 24, 38, 43, 75]
  const FAIL = [2, 3, 4, 5, 37, 39, 76]
  if (OK.includes(item.minor)) return "success"
  if (FAIL.includes(item.minor)) return "error"
  return "info"
}

function resolveName(item) {
  const raw = item.name
  if (!raw || isHashed(raw)) return "Sin nombre"
  return raw
}

function resolveCardId(item) {
  const raw = item.employeeNoString || item.cardNo
  if (!raw) return "—"
  if (isHashed(raw)) return `${raw.slice(0, 8).toUpperCase()}... (cifrado)`
  return raw
}

function downloadBuffer(buffer, filename) {
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

const BRAND_BLUE = "092147"
const WHITE = "FFFFFFFF"

const styleTitle = {
  font: { name: "Arial", size: 12, bold: true, color: { argb: WHITE } },
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: BRAND_BLUE } },
  alignment: { horizontal: "center", vertical: "middle" },
}

const styleHeader = {
  font: { name: "Arial", size: 10, bold: true, color: { argb: WHITE } },
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: BRAND_BLUE } },
  alignment: { horizontal: "center", vertical: "middle" },
  border: {
    top: { style: "thin", color: { argb: "FFAAAAAA" } },
    bottom: { style: "thin", color: { argb: "FFAAAAAA" } },
    left: { style: "thin", color: { argb: "FFAAAAAA" } },
    right: { style: "thin", color: { argb: "FFAAAAAA" } },
  },
}

const styleDataBase = isAlt => ({
  font: { name: "Arial", size: 9 },
  fill: {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: isAlt ? "FFF8FAFC" : "FFFFFFFF" },
  },
  alignment: { vertical: "middle", wrapText: true },
  border: {
    top: { style: "hair", color: { argb: "FFE2E8F0" } },
    bottom: { style: "hair", color: { argb: "FFE2E8F0" } },
    left: { style: "hair", color: { argb: "FFE2E8F0" } },
    right: { style: "hair", color: { argb: "FFE2E8F0" } },
  },
})

const styleOk = {
  font: { name: "Arial", size: 9, bold: true, color: { argb: "FF166534" } },
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFDCFCE7" } },
  alignment: { horizontal: "center", vertical: "middle" },
}

const styleFail = {
  font: { name: "Arial", size: 9, bold: true, color: { argb: "FF991B1B" } },
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFFEE2E2" } },
  alignment: { horizontal: "center", vertical: "middle" },
}

const styleInfo = {
  font: { name: "Arial", size: 9, color: { argb: "FF475569" } },
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFF1F5F9" } },
  alignment: { horizontal: "center", vertical: "middle" },
}

function applyStyle(cell, style) {
  if (style.font) cell.font = style.font
  if (style.fill) cell.fill = style.fill
  if (style.alignment) cell.alignment = style.alignment
  if (style.border) cell.border = style.border
}

export async function exportLogsToExcel({
  logs,
  device,
  dateTimeFrom,
  dateTimeTo,
  searchQuery = "",
  photoCache = {},
}) {
  const ExcelJS = await import("exceljs")
  const WorkbookClass = ExcelJS.Workbook ?? ExcelJS.default?.Workbook

  if (!WorkbookClass) {
    throw new Error("No se pudo cargar ExcelJS. Verifica: npm install exceljs")
  }

  const wb = new WorkbookClass()
  wb.creator = "micasita"
  wb.created = new Date()

  const ok = logs.filter(l => getAccessResult(l) === "success").length
  const fail = logs.filter(l => getAccessResult(l) === "error").length
  const info = logs.length - ok - fail

  const HEADERS = [
    "#",
    "Foto",
    "Fecha / Hora",
    "Nombre",
    "Cédula / ID",
    "Detalle",
    "Puerta",
    "Resultado",
  ]
  const ROW_TITULO = 1
  const ROW_REPOR = 2
  const ROW_EMPTY = 3
  const ROW_HEADER = 4
  const ROW_DATA = 5
  const IMG_ROW_H = 120

  const NOMBRE_REPORTE = `Registros de Acceso — ${moment(dateTimeFrom).format("DD/MM/YYYY HH:mm")} al ${moment(dateTimeTo).format("DD/MM/YYYY HH:mm")}${
    searchQuery ? ` — Filtro: "${searchQuery}"` : ""
  }  |  Total: ${logs.length} `

  const ws = wb.addWorksheet("Registros", {
    pageSetup: {
      paperSize: 9,
      orientation: "landscape",
      fitToPage: true,
      fitToWidth: 1,
    },
    views: [{ state: "frozen", ySplit: ROW_HEADER }],
  })

  const IMG_W_PX = 120
  const IMG_H_PX = 90
  const COL_B_W = Math.ceil(IMG_W_PX / 7) + 1

  ws.columns = [
    { width: 8 },
    { width: COL_B_W },
    { width: 26 },
    { width: 36 },
    { width: 28 },
    { width: 45 },
    { width: 14 },
    { width: 20 },
  ]

  const NUM_COLS = HEADERS.length

  ws.mergeCells(ROW_TITULO, 1, ROW_TITULO, NUM_COLS)
  const cellTitulo = ws.getCell(ROW_TITULO, 1)
  cellTitulo.value = device.nombre
  applyStyle(cellTitulo, styleTitle)
  ws.getRow(ROW_TITULO).height = 22

  ws.mergeCells(ROW_REPOR, 1, ROW_REPOR, NUM_COLS)
  const cellRepor = ws.getCell(ROW_REPOR, 1)
  cellRepor.value = NOMBRE_REPORTE
  applyStyle(cellRepor, styleTitle)
  ws.getRow(ROW_REPOR).height = 22

  ws.getRow(ROW_EMPTY).height = 6

  const headerRow = ws.getRow(ROW_HEADER)
  headerRow.height = 20
  HEADERS.forEach((h, i) => {
    const cell = headerRow.getCell(i + 1)
    cell.value = h
    applyStyle(cell, styleHeader)
  })

  for (let i = 0; i < logs.length; i++) {
    const item = logs[i]
    const result = getAccessResult(item)
    const isAlt = i % 2 === 1
    const base = styleDataBase(isAlt)
    const row = ws.getRow(ROW_DATA + i)
    row.height = IMG_ROW_H

    const setData = (col, value, overrideStyle = null) => {
      const cell = row.getCell(col)
      cell.value = value
      applyStyle(cell, overrideStyle ?? base)
    }

    setData(1, i + 1, {
      ...base,
      font: { name: "Arial", size: 9, bold: true, color: { argb: "FF94A3B8" } },
      alignment: { horizontal: "center", vertical: "middle" },
    })
    setData(2, "", base)
    setData(
      3,
      item.time ? moment(item.time).format("DD/MM/YYYY HH:mm:ss") : "—",
      { ...base, alignment: { horizontal: "center", vertical: "middle" } }
    )
    setData(4, resolveName(item), {
      ...base,
      font: { name: "Arial", size: 9, bold: !isHashed(item.name || "") },
    })
    setData(5, resolveCardId(item), {
      ...base,
      font: { name: "Courier New", size: 9 },
    })
    setData(6, getMinorLabel(item.minor), base)
    setData(7, item.doorNo ?? "—", {
      ...base,
      alignment: { horizontal: "center", vertical: "middle" },
    })

    const resultStyle =
      result === "success"
        ? styleOk
        : result === "error"
          ? styleFail
          : styleInfo
    const resultLabel =
      result === "success"
        ? "✅ Permitido"
        : result === "error"
          ? "❌ Denegado"
          : "ℹ️ Info"
    setData(8, resultLabel, resultStyle)
  }

  for (let i = 0; i < logs.length; i++) {
    const item = logs[i]
    if (!item.pictureURL) continue

    const buffer = photoCache[item.pictureURL]
    if (!buffer || buffer === "error") continue

    try {
      const imageId = wb.addImage({ buffer, extension: "jpeg" })
      ws.addImage(imageId, {
        tl: { col: 1.05, row: ROW_DATA + i - 1 + 0.05 },
        ext: { width: IMG_W_PX, height: IMG_H_PX },
        editAs: "oneCell",
      })
    } catch {
      // imagen inválida — celda queda vacía
    }
  }

  const wsSummary = wb.addWorksheet("Resumen")
  wsSummary.columns = [{ width: 28 }, { width: 30 }]

  wsSummary.mergeCells("A1:B1")
  const st = wsSummary.getCell("A1")
  st.value = device.nombre
  applyStyle(st, styleTitle)
  wsSummary.getRow(1).height = 22

  wsSummary.mergeCells("A2:B2")
  const sr = wsSummary.getCell("A2")
  sr.value = "Resumen — Registros de Acceso"
  applyStyle(sr, styleTitle)
  wsSummary.getRow(2).height = 22

  wsSummary.addRow([])

  const addSum = (label, value, bold = false) => {
    const row = wsSummary.addRow([label, value])
    row.getCell(1).font = { name: "Arial", size: 10, bold }
    row.getCell(2).font = {
      name: "Arial",
      size: 10,
      color: { argb: "FF2563EB" },
    }
    row.getCell(1).alignment = { vertical: "middle" }
    row.getCell(2).alignment = { vertical: "middle" }
  }

  addSum("Dispositivo", device.nombre, true)
  addSum("Ubicación", device.ubicacion || "—")
  addSum("Desde", moment(dateTimeFrom).format("DD/MM/YYYY HH:mm"))
  addSum("Hasta", moment(dateTimeTo).format("DD/MM/YYYY HH:mm"))
  if (searchQuery) addSum("Filtro aplicado", searchQuery)
  wsSummary.addRow([])
  addSum("Total registros", logs.length, true)
  addSum("Permitidos", ok)
  addSum("Denegados", fail)
  addSum("Info", info)
  wsSummary.addRow([])
  addSum("Generado el", moment().format("DD/MM/YYYY HH:mm:ss"))

  const xlsxBuffer = await wb.xlsx.writeBuffer()
  downloadBuffer(xlsxBuffer, `${device.nombre} Registros de Acceso.xlsx`)
}
